module.exports = __webpack_public_path__ + "static/media/occasions-variety.435dd69b.jpg";